export const alcances = [
    'LOCAL',
    'COMUN',
    'REPORTADO'
]

export const estados = [
    'ACTIVO',
    'DESCARTADO',
    'ARCHIVADO'
]